// Docs
// https://marmelab.com/react-admin/Show.html#actions
// https://github.com/marmelab/react-admin/blob/master/docs/Actions.md
// https://reactjs.org/docs/conditional-rendering.html

import React from 'react';
import { Datagrid, DeleteButton, EditButton, ListButton, ShowButton, TextField } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import DeleteButtonDisabledWithDialog from '../../components/DeleteButtonDisabledWithDialog';
import CardActions from '@material-ui/core/CardActions';

export const CustomShowActions = ({ basePath, data, resource, relatedWebsites }) => {
  let isDeleteTemplatePossible = relatedWebsites.websites !== null && relatedWebsites.ids && relatedWebsites.ids.length === 0;

  return (
    <CardActions>
      <ListButton basePath={basePath}/>
      <EditButton basePath={basePath} record={data} resource={resource}/>

      {isDeleteTemplatePossible ? (
        <DeleteButton basePath={basePath} record={data} resource={resource}/>
      ) : (
        <DeleteButtonDisabledWithDialog>
          <Typography variant="subtitle1">You cannot delete the template as it is used by following websites</Typography>
          <Datagrid basePath="/websites" data={relatedWebsites.websites} currentSort={{}} ids={relatedWebsites.ids}>
            <TextField label="Name" source="name" sortable={false}/>
            <ShowButton/>
          </Datagrid>
        </DeleteButtonDisabledWithDialog>
      )
      }
    </CardActions>
  );
};

export const CustomEditActions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath}/>
    <ShowButton basePath={basePath} record={data} resource={resource}/>
  </CardActions>
);
